import { render, staticRenderFns } from "./AddGraphs.vue?vue&type=template&id=718b9971&"
import script from "./AddGraphs.vue?vue&type=script&lang=js&"
export * from "./AddGraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports